export default __webpack_public_path__ + "static/PSI_PSSE-c38fe087a510c6e09e0dc95a3a13f51e.png";